{
  "sideNav": [
    {
      "label": "",
      "items": [
        {
          "icon": "bars-progress",
          "label": "menu.projects",
          "id": "/projects",
          "link": "/projects"
        },
        {
          "icon": "circle-info",
          "label": "menu.informations",
          "id": "/informations",
          "link": "/informations"
        }
      ]
    },
    {
      "label": "menu.settings",
      "items": [
        {
          "icon": "users",
          "label": "menu.users_administration",
          "id": "/users",
          "link": "/users",
          "roles": [
            "GUP.Admin"
          ]
        },
        {
          "icon": "gear",
          "label": "menu.delivery_addresses",
          "id": "/address",
          "link": "/address",
          "roles": [
            "GUP.Admin"
          ]
        }
      ]
    }
  ],
  "metaNav": [
    {
      "label": "footer.privacy",
      "url": "/data-privacy"
    },
    {
      "label": "footer.imprint",
      "url": "https://www.pasm.de/index.php/impressum/"
    }
  ]
}
